// Identificadores visuais compatíveis com jair_clientes (06/10/2026).
export const themeOptions = [
  { value: 'light-theme', label: 'Claro' },
  { value: 'dark-theme', label: 'Escuro' },
  { value: 'semi-dark', label: 'Semi Escuro' },
  { value: 'minimal-theme', label: 'Minimal' }
]

export const paletteOptions = [
  { value: 'headercolor1', label: 'Azul principal' },
  { value: 'headercolor2', label: 'Cinza' },
  { value: 'headercolor3', label: 'Vermelho' },
  { value: 'headercolor4', label: 'Verde' },
  { value: 'headercolor5', label: 'Roxo' },
  { value: 'headercolor6', label: 'Marrom' },
  { value: 'headercolor7', label: 'Rosa' },
  { value: 'headercolor8', label: 'Âmbar' },
  { value: 'headercolor9', label: 'Azul royal' },
  { value: 'headercolor10', label: 'Azul oceano' },
  { value: 'headercolor11', label: 'Azul aço' },
  { value: 'headercolor12', label: 'Verde esmeralda' },
  { value: 'headercolor13', label: 'Verde floresta' },
  { value: 'headercolor14', label: 'Verde oliva' },
  { value: 'headercolor15', label: 'Escalador' },
  { value: 'headercolor16', label: 'Azul marinho' },
  { value: 'headercolor17', label: 'Azul cobalto' },
  { value: 'headercolor18', label: 'Azul céu sóbrio' },
  { value: 'headercolor19', label: 'Turquesa profundo' },
  { value: 'headercolor20', label: 'Verde jade' },
  { value: 'headercolor21', label: 'Verde pinho' },
  { value: 'headercolor22', label: 'Verde sálvia' },
  { value: 'headercolor23', label: 'Laranja Escalador' },
  { value: 'headercolor24', label: 'Grafite azulado' },
  { value: 'headercolor25', label: 'Azul principal + ciano' },
  { value: 'headercolor26', label: 'Azul principal + esmeralda' },
  { value: 'headercolor27', label: 'Azul principal + âmbar' },
  { value: 'headercolor28', label: 'Azul principal + violeta' },
  { value: 'headercolor29', label: 'Azul principal + coral' },
  { value: 'headercolor30', label: 'Azul principal + rosa' }
]
